<template>
  <div>
    <exo-input-name class="ml-2" :root="_self" />
    <v-row>
      <v-col><ScreeningCatalogueAnalysisGroupAndSatelliteCard /> </v-col>
      <v-col>
        <MeasurementsSelector
          :tlesInput.sync="inputs.measurementsSelector.tles"
          :isValidInput.sync="isValidTLEs"
          :disabled="isDisabled"
        />
      </v-col>
      <v-col>
        <TLEScreeningRequest
          :tleScreeningRequest.sync="inputs.analysisRequest"
        ></TLEScreeningRequest>
      </v-col>
    </v-row>
    <v-col ref="NumericalMissionErrorDisplay"> </v-col>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import plotLayout from '../../mixins/plotLayout.js'
import dataTools from '../../tools/data.js'
import { mapGetters } from 'vuex'
import MeasurementsSelector from './MeasurementsSelector.vue'
import ScreeningCatalogueAnalysisGroupAndSatelliteCard from './ScreeningCatalogueAnalysisGroupAndSatelliteCard.vue'
import TLEScreeningRequest from './TLEScreeningRequest.vue'
export default {
  name: 'ScreeningCatalogueAnalysisRequest',

  mixins: [formMixin, numericalMixin, plotLayout],
  components: {
    MeasurementsSelector,
    TLEScreeningRequest,
    ScreeningCatalogueAnalysisGroupAndSatelliteCard
  },
  props: {
    standalone: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'missions',
      'currentMission',
      'currentUser',
      'screeningAlerts'
    ]),
    inputsValid() {
      let fieldsState = this.verifyPropertiesList(
        this.getRequiredPropertiesList(this.inputs),
        this.inputs,
        true
      )
      fieldsState =
        fieldsState &&
        this.verifyPropertiesList(
          this.getOptionalPropertiesList(this.inputs),
          this.inputs,
          false
        )
      // if impossible to validate a form : uncomment the code in verifyPropertiesList to understand the problematic field

      return (
        this.inputNameState &&
        fieldsState &&
        this.isValidTLEs &&
        this.inputs.analysisRequest.alertDefinitions.length != 0
      )
    },
    isDisabled() {
      return this.disabled || this.inputs.saving
    }
  },

  async mounted() {
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    this.$root.$on('copy-mission', this.copyMission)
    this.$root.$on('create-mission', this.createMission)
    this.refreshForm()
    if (this.standalone === false) {
      this.$emit('initSaveFunction', this.submitForm)
    }
  },

  watch: {
    inputsValid(newValue) {
      this.$emit('updateValid', newValue)
    },
    'inputs.saving'(newValue) {
      this.$emit('updateSaving', newValue)
    },
    'inputs.id'(newValue) {
      this.$emit('updateRequestId', newValue)
    },
    screeningAlerts(newValue) {
      this.inputs.analysisRequest.alertDefinitions = newValue
    }
  },

  beforeDestroy() {
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
    this.$root.$off('copy-mission', this.copyMission)
    this.$root.$off('create-mission', this.createMission)
  },

  data() {
    return {
      enumPropertiesList: this.getEnumProperties(),
      modalRef: { content: [] },
      showModal: false,
      inputs: {
        editing: true,
        type: this.getDefaultValue('typeName'),
        layout: this.getDefaultValue('layout'), // to save the dashboard, should be optional in fieldsdescription to be automatically copied
        analysisRequest: { alertDefinitions: [] },
        measurementsSelector: { tles: [] },
        saving: false
      },
      modalInfo: { title: '', content: '', config: {} },
      modalError: { title: '', content: '' },
      displayed: null,
      enableFormCache: false,
      isValidTLEs: false
    }
  },

  methods: {
    refreshTable() {},

    getCurrentFormTitle() {
      return this.inputs.type + ' Mission'
    },

    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.inputs.type = mission.type
        this.inputs.editing = false
        //TODO: Allow user to define these inputs
        this.inputs.measurementsSelector = { tles: [] }
        this.inputs.analysisRequest = { alertDefinitions: [] }

        this.sendFormToServer()
      }
    },

    currentMissionUpdatedHandler() {
      this.refreshForm()
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
        }
      }
      this.inputs.analysisRequest = { alertDefinitions: [] }

      this.inputs.measurementsSelector = { tles: [] }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        const editing = this.inputs.editing
        this.edit(this.currentMission, 0)
        this.inputs.editing = editing
      }
    },

    updateAllReferences() {
      this.inputs.editing = true
      this.checkReferences(this.currentMission, this.inputs)
    },

    checkReferences(missionSource, missionToUpdate) {
      if (missionSource != null && missionToUpdate != null) {
        for (let field in this.getPropertiesDescription()) {
          if (missionSource[field] != null && missionToUpdate[field] != null) {
            if (
              missionSource[field].id != null &&
              missionSource[field].id === missionToUpdate[field].id
            ) {
              missionToUpdate[field] = missionSource[field]
            }
          }
        }
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    // redefine from form.js to keep the form open on the upadted data
    async onSave() {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    async onCreate() {
      let self = this
      let objectName = this.inputs.name.trim()
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          self.inputs.saving = false
          self.clearForm()
          this.$root.$emit('update-mission-list')
          //Go into editing mode
          this.inputs.editing = true
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
        })
        .catch((e) => {
          self.inputs.saving = false
          self.displayMessage(
            'Error creating ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          throw e
        })
    },
    getResultFieldType(field) {
      return dataTools.getFieldTypeFromPath(
        ['maneuverReport', field],
        'SimulationResult',
        null
      )
    },

    // methods to mange form & table like other components

    getCurrentFormType() {
      return 'ScreeningCatalogueAnalysisRequest'
    }
  }
}
</script>
